import { ContactUsButton } from '@components/ContactUsButton/ContactUsButton'
import { Alert, Box, Typography, useTheme } from '@mui/material'
import type { CSSProperties } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export const CTAPcfAtScale = ({
	justifyContent = 'initial',
	variant = 'default',
	translationContext,
}: {
	justifyContent?: CSSProperties['justifyContent']
	variant?: 'default' | 'alert'
	translationContext?: string
}) => {
	const theme = useTheme()
	const { t } = useTranslation()
	if (variant === 'alert') {
		return (
			<Alert
				severity="info"
				variant="filled"
				action={<ContactUsButton variant="button" />}
			>
				{t('pcfCallToAction', { context: translationContext })}
			</Alert>
		)
	}
	return (
		<Box
			display="flex"
			alignItems="center"
			pb={2}
			mt={2}
			justifyContent={justifyContent}
		>
			<Typography variant="body2" color={theme.palette.text.secondary}>
				{/* eslint-disable react/jsx-no-literals */}
				<Trans i18nKey="pcfCallToActionWithLink" context={translationContext}>
					Looking to calculate product carbon footprints at scale for your
					product portfolio? Please <ContactUsButton variant="link" />
				</Trans>
				{/* eslint-enable react/jsx-no-literals */}
			</Typography>
		</Box>
	)
}
